<template>
    <div>
        <b-button
            v-if="!startingUpdate"
            variant="primary"
            @click="triggerUpdate()"
        >
            Mettre à jour
        </b-button>
        <div v-else class="d-flex flex-column align-items-end">
            <span>
                {{ updateProgressInfos.info_to_display }}
                <i
                    v-if="!updateProgressInfos.is_updating"
                    class="fas fa-spinner-third fa-spin"
                ></i>
            </span>
            <b-progress
                v-if="updateProgressInfos.is_updating"
                class="w-50 mb-2"
                :value="updateProgressInfos.progress"
                max="100"
                variant="success"
            ></b-progress>
        </div>
    </div>
</template>

<script>
import ToastHandler from '../../common/mixins/ToastHandler.vue'

export default {
    name: 'UpdateHandler',

    mixins: [ToastHandler],

    props: {
        year: {
            required: true,
            type: Number,
        },
        accountingFirmCompanyId: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            updateProgressInfos: {
                info_to_display: 'Début de la mise à jour',
                is_updating: false,
            },
            startingUpdate: false,
        }
    },

    methods: {
        async triggerUpdate() {
            this.startingUpdate = true
            await this.updateAccountingFirmCompany()
            await this.getUpdateProgression()

            const interval = setInterval(() => {
                this.getUpdateProgression()
                if (!this.updateProgressInfos.is_updating) {
                    this.startingUpdate = false
                    clearInterval(interval)
                    this.$emit('accounting-firm-company-updated')
                }
            }, 1000)
        },

        async updateAccountingFirmCompany() {
            try {
                await this.$axios.get(
                    `cador/afc/${this.year}/${this.accountingFirmCompanyId}/update`
                )
            } catch (e) {
                this.showErrorToast(e)
            }
        },

        async getUpdateProgression() {
            try {
                const response = await this.$axios.get(
                    `cador/afc/${this.year}/${this.accountingFirmCompanyId}/progress`
                )
                this.updateProgressInfos = response.data
            } catch (e) {
                this.showErrorToast(e)
            }
        },
    },
}
</script>

<style scoped></style>
